import filterTypes from "../data/filter-types";

/**
 * Find filter value.
 * @param {String} name
 * @param {Array} activeFilters
 * @returns {string|[*]}
 */
const findFilterValue = (name, activeFilters) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const index in activeFilters) {
        if (activeFilters[index] && activeFilters[index].fieldName === name) {
            return activeFilters[index].fieldValue;
        }
    }
    return "";
};

export const findsearchOperation = (name, activeFilters) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const index in activeFilters) {
        if (activeFilters[index] && activeFilters[index].searchOperation === name) {
            return activeFilters[index].searchOperation;
        }
    }
    return filterTypes.EQUALS.value;
};

export default findFilterValue;



// WEBPACK FOOTER //
// ./src/helpers/find-filter-value.js